export enum ALERT_VARIANTS {
  INFO = 'info',
  WARNING = 'warning',
  DANGER = 'danger',
  SUCCESS = 'success',
  NEUTRAL = 'neutral',
}
